import { WalletUtils } from '@/api/wallet/walletUtils'
import { JUST_WALLET } from '@/config'

const ACCOUNT_AUTH_PATHS = ['/pass/login', '/pass/register', '/pass/reset']

/** 当前环境是否具备 DApp 钱包注入（以太坊 / Tron） */
export function isDappSupported() {
  if (typeof window === 'undefined') {
    return false
  }
  return (
    WalletUtils.isEthereumWalletAvailable() ||
    WalletUtils.isTronLinkAvailable()
  )
}

/** 是否强制只走钱包登录（忽略账号密码页） */
export function shouldUseWalletLogin() {
  return JUST_WALLET
}

/** 从地址栏读取邀请码：根路径 ?invetedCode= 或路由 query */
export function readInvetedCode(routeQuery) {
  const fromRoute = routeQuery && routeQuery.invetedCode
  if (fromRoute) {
    return String(fromRoute).trim()
  }
  if (typeof window === 'undefined') {
    return ''
  }
  const fromSearch = new URLSearchParams(window.location.search || '').get('invetedCode')
  if (fromSearch) {
    return String(fromSearch).trim()
  }
  const hash = window.location.hash || ''
  const qIndex = hash.indexOf('?')
  if (qIndex >= 0) {
    const fromHash = new URLSearchParams(hash.slice(qIndex + 1)).get('invetedCode')
    if (fromHash) {
      return String(fromHash).trim()
    }
  }
  return ''
}

/** 当前可用的邀请码：地址栏优先，其次是打开邀请链接时记下的值 */
export function getInvetedCode(routeQuery) {
  const fromUrl = readInvetedCode(routeQuery)
  if (fromUrl) {
    return fromUrl
  }
  if (typeof sessionStorage === 'undefined') {
    return ''
  }
  return String(sessionStorage.getItem('invetedCode') || '').trim()
}

/** 邀请码已交给注册页后，去掉根路径上的参数，避免后续每次跳转都被拉回注册 */
export function clearInvetedCodeSearch() {
  if (typeof window === 'undefined') {
    return
  }
  const url = new URL(window.location.href)
  if (!url.searchParams.has('invetedCode')) {
    return
  }
  url.searchParams.delete('invetedCode')
  window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash)
}

/** 需要登录时的入口：仅强制钱包模式才进 /empty，否则进账号登录页（页内可选钱包） */
export function getAuthEntryPath(query) {
  if (JUST_WALLET) {
    return '/empty'
  }
  if (query && query.invetedCode) {
    return '/pass/register'
  }
  return '/pass/login'
}

/** 未登录时的注册入口 */
export function getSignupPath() {
  return JUST_WALLET ? '/empty' : '/pass/register'
}

/** 未登录时允许访问的路径（除 OAuth 等白名单外） */
export function isAllowedPathWithoutLogin(path) {
  if (path === '/api/loginCallback/google') {
    return true
  }
  if (shouldUseWalletLogin()) {
    return path === '/empty'
  }
  return ACCOUNT_AUTH_PATHS.includes(path)
}
